import styled, { css } from 'styled-components';

import {
  colorBlack900,
  colorGrey200,
  colorSecondary500,
  colorWhite,
  fontFamilyPrimary,
} from '@/styleUtils';

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${colorBlack900};
  background: ${colorWhite};
  border: 1px solid ${colorGrey200};
  border-radius: 4px;
  width: 144px;
  height: 48px;
  justify-content: center;
  padding: 12px 36px 12px 16px;
  transition: 0.2s;
  position: relative;
  flex-shrink: 0;

  &:hover {
    opacity: 0.8;
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translate(0, -50%);
    width: 0;
    height: 0;
    border-left: 5.5px solid transparent;
    border-right: 5.5px solid transparent;
    border-top: 5px solid ${colorBlack900};
  }

  &[data-active='true'] {
    &::after {
      transform: rotate(-180deg);
    }
  }
`;

export const FilterButtonText = styled.span`
  font: 400 16px/100% ${fontFamilyPrimary};
`;

export const IconFiltersWrapper = styled.div`
  display: flex;
  gap: 8px;
  position: relative;
  width: 18px;

  ${({ $isActive }) => {
    if ($isActive) {
      return css`
        &:after {
          content: '';
          position: absolute;
          top: -4px;
          right: -4px;
          z-index: 1;
          width: 12px;
          height: 12px;
          background: ${colorSecondary500};
          border-radius: 50%;
          border: 2px solid ${colorWhite};
        }
      `;
    }

    return ``;
  }}
`;
